import { z } from "zod";

export const FormikRowSchema = z.object({
  totalCapacity: z.string().superRefine((value, ctx) => {
    if (isNaN(parseInt(value))) {
      ctx.addIssue({
        code: "custom",
        message: "Invalid number",
      });
    }
  }),
  additionalSeatsTaken1: z.string().superRefine((value, ctx) => {
    if (isNaN(parseInt(value))) {
      ctx.addIssue({
        code: "custom",
        message: "Invalid number",
      });
    }
  }),
  additionalSeatsTaken2: z.string().superRefine((value, ctx) => {
    if (isNaN(parseInt(value))) {
      ctx.addIssue({
        code: "custom",
        message: "Invalid number",
      });
    }
  }),
});
export type FormikRow = z.infer<typeof FormikRowSchema>;
export const FormikSchema = z.record(z.string(), FormikRowSchema);
export type FormikType = z.infer<typeof FormikSchema>;

export type Capacity = {
  id: string;
  name: string;
  totalCapacity: number;
  offered: number;
  accepted: number;
  waitlisted: number;
  seatsAvailable: number;
  additionalSeatsTaken1: number | undefined;
  additionalSeatsTaken2: number | undefined;
  programs?: Capacity[];
};

export function toFormikInitialValues(capacities: Capacity[]): FormikType {
  return capacities.reduce(
    (accum: FormikType, capacity: Capacity): FormikType => {
      return {
        ...accum,
        [capacity.id]: {
          totalCapacity: capacity.totalCapacity.toString(),
          additionalSeatsTaken1: (
            capacity.additionalSeatsTaken1 ?? 0
          ).toString(),
          additionalSeatsTaken2: (
            capacity.additionalSeatsTaken2 ?? 0
          ).toString(),
        },
        ...capacity.programs?.reduce(
          (programAccum: FormikType, program): FormikType => ({
            ...programAccum,
            [program.id]: {
              totalCapacity: program.totalCapacity.toString(),
              additionalSeatsTaken1: (
                program.additionalSeatsTaken1 ?? 0
              ).toString(),
              additionalSeatsTaken2: (
                program.additionalSeatsTaken2 ?? 0
              ).toString(),
            },
          }),
          {} as FormikType
        ),
      };
    },
    {} as FormikType
  );
}
